import { combineReducers } from 'redux';
import test from './test.js';
import environment from './environment.js';

export default combineReducers({
  test,
  environment
});
